import { ref, computed } from 'vue';
import useFilter from '@/hooks/filter';

const state = ref({
  filter: {
    ...useFilter(),
    applicationKind: { alias: null, name: null },
  },
});
const filter = computed(() => state.value.filter);
const setFilter = (newFilter) => (state.value.filter = newFilter);

export default function useApplicationsFilter() {
  return {
    filter,
    setFilter,
  };
}
